module.exports = __webpack_public_path__ + "img/MR.4904c241.svg";